#@import GliveBooking.Presenters.Booker
#@import GliveBooking.Views.Info
#@import GliveBooking.Views.DatePicker
#@import GliveBooking.Views.TimePicker
#@import GliveBooking.Views.QuantityPicker
#@import GliveBooking.Views.SectionPicker
#@import GliveBooking.Views.PricePicker
#@import GliveBooking.Views.Book
#@export GliveBooking.Views.Booker


class GliveBooking.Views.Booker extends BookingV2.Views.Base

  module: 'glive-booking'

  presenter: GliveBooking.Presenters.Booker

  events:
    'submit form': 'book'
    'click .open .btn': 'open'
    'click .icon-close': 'close'

  className: 'glive-booking-component'

  constructor: ->
    BookingV2.Views.Base.apply this, arguments

    @model.on 'updatedCollections', @renderInfo, this
    @model.on 'updatedCollections', @renderBookButton, this
    @model.on 'updatedCollections', @enableClearButton, this
    @model.on 'updatedCollections', @fixDatesInCalendar, this
    @model.on 'clearAll', @disableClearButton, this

  canRenderOptions: ->
    false

  canRenderPhone: ->
    false

  setOpen: ->
    $(@options.overlapWith).hide() if @options.overlapWith
    @options.isOpen = true

  setOpenAndLocked: ->
    @setOpen()
    @options.isLocked = true

  open: ->
    @setOpen()
    @model.reset()
    @render(fadeIn: true)

  close: ->
    @options.isOpen = false
    @$el.fadeOut =>
      @render()
      $(@options.overlapWith).fadeIn() if @options.overlapWith
      @model.resetOption()

  render: ->
    @$el.hide()
    BookingV2.Views.Base.prototype.render.apply this, arguments
    unless @model.get 'error'
      if @options.isOpen
        @$el.find('[data-info-content]').hide()
        if @model.get 'isSellable'
          @renderInfo()
          @renderPickers()
          @renderClearButton()
        @renderBookButton()
    showMethod = if arguments[0]?.fadeIn is true then 'fadeIn' else 'show'
    @$el[showMethod]()
    this

  renderInfo: ->
    infoContainer = @$el.find('[data-glive-info-content]')
    infoContainer.html((new GliveBooking.Views.Info model: @model).render().el)

  renderPickers: ->
    pickersView = new BookingV2.Views.Pickers
      el: @$el.find('[data-pickers-content]')

    @datePicker = pickersView.add
      view: GliveBooking.Views.DatePicker
      model: @model
      collection: 'dates'
      selection: 'selectedDate'
      selected: @selectDate

    @timePicker = pickersView.add
      view: GliveBooking.Views.TimePicker
      model: @model
      collection: 'times'
      selection: 'selectedTime'
      selected: @selectTime

    @quantityPicker = pickersView.add
      view: GliveBooking.Views.QuantityPicker
      model: @model
      collection: 'quantities'
      selection: 'selectedQuantity'
      selected: @selectQuantity

    @sectionPicker = pickersView.add
      view: GliveBooking.Views.SectionPicker
      model: @model
      collection: 'sections'
      selection: 'selectedSection'
      selected: @selectSection

    @pricePicker = pickersView.add
      view: GliveBooking.Views.PricePicker
      model: @model
      collection: 'prices'
      selection: 'selectedPrice'
      selected: @selectPrice

    pickersView.render()
    pickersView.once 'expanded', => @trigger 'ready'

  renderClearButton: ->
    pickersContainer = @$el.find('[data-pickers-content]')
    pickersContainer.append("<div class='clear-button'>Clear All</div>")
    $('.clear-button').click =>
      @clearAll()

  enableClearButton: ->
    $('.clear-button').addClass('clear-enabled')

  disableClearButton: ->
    $('.clear-button').removeClass('clear-enabled')

  renderBookButton: ->
    bookContainer = @$el.find('[data-book-now-content]')
    bookContainer.html((new GliveBooking.Views.Book model: @model).render().el) if bookContainer.length

  selectDate: (date) =>
    @model.selectDate date

  selectTime: (time) =>
    @model.selectTime time

  selectQuantity: (quantity) =>
    @model.selectQuantity quantity

  selectSection: (section) =>
    @model.selectSection section

  selectPrice: (price) =>
    @model.selectPrice price

  fixDatesInCalendar: ->
    @datePicker.refreshDates()

  clearAll: =>
    @model.clearAll()

  book: (event) ->
    event.stopPropagation()
    @model.book()
    false
